export const ROLE_DEALER = "Dealer";
export const ROLE_ARCHITECT = "Architect";
export const ROLE_GENERAL_CONTRACTOR = "General Contractor";

